import { MdWarning } from 'react-icons/md';
import { AlertDialog } from '@Components/AlertDialog';
import { Intent } from '@Components/designConstants';

interface CancelModalProps {
  show: boolean;
  closeModal: () => void;
  confirmCancel: () => void;
}

export const CancelModal = ({ show, closeModal, confirmCancel }: CancelModalProps) => (
  <AlertDialog
    show={show}
    onHide={closeModal}
    intent={Intent.WARNING}
    icon={<MdWarning size={24} />}
    title='Discard changes?'
    body='Are you sure? Any unsaved changes will be lost.'
    primaryAction={{ onClick: confirmCancel, label: 'Confirm' }}
    secondaryAction={{ onClick: closeModal }}
    passthroughProps={{ 'data-testid': 'cancel-modal' }}
  />
);
